import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { Link } from 'react-router-dom';
import '../App.css';
import tobslogo from '../images/tobs-txt.svg';
import setcastLogo from '../images/Setcast_Logo_Icon_White_RGB.svg';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const { forgotPassword } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email) {
      setError('Please enter your email address');
      return;
    }

    try {
      setError('');
      setMessage('');
      setLoading(true);

      await forgotPassword(email);

      // Even if the email doesn't exist, we show the same message for security
      setMessage('If your email is registered, you will receive a password reset link');
      setEmail(''); // Clear the form
    } catch (err) {
      console.error('Error requesting password reset:', err);
      // Don't expose specific errors for security - always show the same message
      setMessage('If your email is registered, you will receive a password reset link');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="loginForm">
      <form onSubmit={handleSubmit}>
        <div className="loginForm-container">
          <img style={{ height: 150 }} src={tobslogo} alt="Tobs Logo" />
          <h2>Forgot Password</h2>

          <label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="email"
              required
            />
          </label>

          {error && <p className="error">{error}</p>}
          {message && (
            <p className="password-reset-link" style={{ marginTop: '10px' }}>
              {message}
            </p>
          )}

          <button type="submit" className="big-button" disabled={loading}>
            {loading ? 'Sending...' : 'Request Password Reset'}
          </button>

          <Link to="/" className="password-reset-link" style={{ marginTop: '10px' }}>
            Back to Login
          </Link>
        </div>
      </form>
      <div className="footer-logo-container">
        <img style={{ height: 60 }} src={setcastLogo} alt="Setcast Logo" />
      </div>
    </div>
  );
};

export default ForgotPassword;
